import axios from "axios";
import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import LocalStorageService from "../../core/services/local-storage.service";
import { getInternationalNumberSystem } from "../../core/utility/utility";
import { getApiUrl } from "../../utils/baseUrl";
import commaFormat from "../../utils/commaFormat";
import globalErrorHandling, { handleDownloadError, isJsonResponse } from "../../utils/utils";
import NoSearchDataComponent from "../country-components/no-search-data";
import ReactTableTrademo from "../trademo-datatable/react-table-trademo";
import LoaderImg from "./../../assets/images/loader.gif";
import ViewAllTwoLevelAnalytics from "../analytics-components/view-all-two-level-analytics";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import { getFirstColNameForRussia, getSecondColNameForRussia, getThirdColNameForRussia } from "../../utils/getRowName";
import "./viewAnalyticsReport.scss";
import { ChevronLeft, ChevronRight } from "react-feather";
import DownloadModal from "./DownloadModal";

const localStorageService = LocalStorageService.getService();
const analyticsFieldKeys = [
  {
    value: "country_of_origin",
    label: "Countries of Origin",
  },
  {
    value: "derived_origin_destination_country_english",
    label: "Countries of Origin",
  },
  {
    value: "mexican_trading_entity_state",
    label: "Consignee States",
  },
  {
    value: "customs_house_name",
    label: "Customs Houses",
  },
  {
    value: "derived_mode_of_transport_english",
    label: "Mode of Transportation",
  },
  {
    value: "derived_port_of_unlading",
    label: "Ports of Unlading",
  },
  {
    value: "foreign_port_of_lading",
    label: "Foreign Ports of Lading",
  },
  {
    value: "port_of_lading",
    label: "Ports of lading",
  },
  {
    value: "port_of_unlading",
    label: "Ports of Unlading",
  },
  {
    value: "derived_consignee_state",
    label: "Consignee States",
  },
  {
    value: "derived_carrier_name",
    label: "Carrier",
  },
  {
    value: "carrier_name",
    label: "Carrier",
  },
  {
    value: "derived_nvocc_name",
    label: "NVOCC",
  },
  {
    value: "derived_port_of_lading_english",
    label: "Port of Lading",
  },
  {
    value: "derived_vocc_name",
    label: "VOCC",
  },
  {
    value: "trade_port",
    label: "Trade Port",
  },
  {
    value: "trade_origin_country",
    label: "Trade Origin Country",
  },
  {
    value: "trade_purchase_country",
    label: "Trade Purchase Country",
  },
  {
    value: "trade_city_destination_country",
    label: "Trade City Country",
  },
  {
    value: "trade_port_destination_country",
    label: "Trade Port Country",
  },
  {
    value: "trade_country",
    label: "Trade Country",
  },
  {
    value: "sections",
    label: "Sections",
  },
  {
    value: "derived_hs_codes",
    label: "2-digit HS Codes",
  },
  {
    value: "derived_colombia_origin_position_state_name",
    label: "States of Origin",
  },
  {
    value: "derived_colombia_origin_state_name",
    label: "States of Export",
  },
  {
    value: "derived_place_of_departure",
    label: "Places of Departure",
  },
  {
    value: "derived_customs_office_name",
    label: "Custom Offices",
  },
  {
    value: "derived_export_modality_english",
    label: "Export Modes",
  },
  {
    value: "derived_transportation_route_english",
    label: "Mode of Transportation",
  },
  {
    value: "derived_certificate_of_origin",
    label: "Certificates of Origin",
  },
  {
    value: "derived_payment_method_english",
    label: "Payment Methods",
  },
  {
    value: "trade_origin_state_destination_country",
    label: "Trade Routes (State of Origin → Country of Destination)",
  },
  {
    value: "trade_export_state_destination_country",
    label: "Trade Routes (State of Export → Country of Import)",
  },
  {
    value: "trade_origin_export_state_departure_destination",
    label: "Trade Routes (State of Origin → State of Export → Place of Departure → Country of Destination)",
  },
  {
    value: "derived_country_of_destination",
    label: "Countries of Import",
  },
  {
    value: "derived_country_of_provenance_english",
    label: "Countries of Provenance",
  },
  {
    value: "derived_country_of_purchase_english",
    label: "Country of Export",
  },
  {
    value: "derived_departure_port_name",
    label: "Ports of Lading",
  },
  {
    value: "derived_arrival_port_name",
    label: "Port of Unlading",
  },
  {
    value: "derived_shipper_state",
    label: "Shipper States",
  },
  {
    value: "hs_code",
    label: "Top HS Codes",
  },
  {
    value: "hsCode",
    label: "2-digit HS Codes",
  },
  {
    value: "derived_hs_code",
    label: "HS Codes",
  },
  {
    value: "section",
    label: "Top Sections",
  },
  {
    value: "port_of_destination_country",
    label: "Countries of Destination",
  },
  {
    value: "derived_carrier_name",
    label: "Carriers",
  },
  {
    value: "derived_nvocc_name",
    label: "NVOCC",
  },
  {
    value: "derived_vocc_name",
    label: "VOCC",
  },
  {
    value: "trade_port",
    label: "Trade Routes (Port of Lading → Port of Unlading)",
  },
  {
    value: "trade_country",
    label: "Trade Routes (Shipper State → Country of Import)",
  },
  {
    value: "notify_party_name",
    label: "Notify Parties",
  },
  {
    value: "port_of_lading",
    label: "All Ports of Unlading",
  },
  {
    value: "port_of_unlading",
    label: "Ports of Lading",
  },
  {
    value: "derived_port_of_lading",
    label: "Ports of Lading",
  },
  {
    value: "derived_country_of_destination_english",
    label: "Countries of Import",
  },
  {
    value: "derived_custom_office_destination_name",
    label: "Custom House of Destination",
  },
  {
    value: "derived_custom_office_entry_name",
    label: "Custom House of Entry",
  },
  {
    value: "derived_country_of_origin_english",
    label: "Countries of Origin",
  },
  {
    value: "custom",
    label: "Customs Houses",
  },
  {
    value: "shipper_city",
    label: "Shipper Cities",
  },
  {
    value: "derived_port_of_unlading_english",
    label: "Ports of Unlading",
  },
  {
    value: "carrier_name",
    label: "Carrier Names",
  },
  {
    value: "derived_country_of_destination_name",
    label: "Countries of Import",
  },
  {
    value: "puerto",
    label: "Ports of Lading",
  },
  {
    value: "derived_customs_office_zone_name",
    label: "Customs Office Zone",
  },
  {
    value: "derived_sale_condition_english",
    label: "Sale Conditions",
  },
  {
    value: "derived_sections",
    label: "Sections",
  },
  {
    value: "derived_country_of_export_english",
    label: "Countries of Export",
  },
  {
    value: "derived_country_of_origin",
    label: "Countries of Export",
  },
  {
    value: "derived_country_of_export",
    label: "Countries of Export",
  },
  {
    value: "derived_country_of_purchase",
    label: "Countries of Purchase",
  },
  {
    value: "derived_country_of_exporter",
    label: "Countries of Shipper",
  },
  {
    value: "exporter_city_name_english",
    label: "Shipper Cities",
  },
  {
    value: "derived_colombia_destination_state",
    label: "Destination States",
  },
  {
    value: "derived_customs_office_name",
    label: "Customs Office",
  },
  {
    value: "place_of_entry_name",
    label: "Places of Entry",
  },
  {
    value: "derived_colombia_importer_state",
    label: "Consignee States",
  },
  {
    value: "trade_origin_country_destination_state",
    label: "Trade Routes (Country of Origin → Destination State)",
  },
  {
    value: "trade_export_country_destination_state",
    label: "Trade Routes (Country of Export → Destination State)",
  },
  {
    value: "trade_origin_export_country_destination_state",
    label: "Trade Routes (Country of Origin → Country of Export → Destination State)",
  },
  {
    value: "trade_exporter_city_destination_state",
    label: "Trade Routes (Shipper City → Destination State)",
  },
  {
    value: "trade_custom_destination_country",
    label: "Trade Routes (Customs House → Country of Import)",
  },
  {
    value: "customs_office",
    label: "Customs Offices",
  },
  {
    value: "trade_exporter_city_importer_state",
    label: "Trade Routes (Shipper City → Consignee State)",
  },
  {
    value: "trade_port_origin_country",
    label: "Trade Routes (Country of Export → Port of Unlading)",
  },
  {
    value: "derived_country_of_origin_name",
    label: "Countries of Origin",
  },
  {
    value: "derived_custom_office_destination_name_derived_country_of_destination_english",
    label: "Trade Country",
  },
  {
    value: "derived_port_of_lading_port_of_lading_country_customs_house_name",
    label: " Trade Routes (Port of Lading → Customs House)",
  },
  {
    value: "derived_country_of_origin_port_of_lading_country_country_of_export",
    label: " Trade Routes (Country of Origin → Port of Lading Country → Country of Export)",
  },
  {
    value: "port_of_destination",
    label: "Ports of Unlading",
  },
  {
    value: "trade_customs_destination_country",
    label: "Trade Routes (Customs House -> Country of Import)",
  },
  {
    value: "trade_customs_port",
    label: "Trade Routes (Customs House -> Port of Unlading)",
  },
  {
    value: "country_of_export",
    label: "Top Countries of Export",
  },
  {
    value: "country_of_destination",
    label: "Countries Of Import",
  },
  {
    value: "derived_customs_house_name_country_of_destination",
    label: " Trade Routes (Customs House Name → Country of Import)",
  },
  {
    value: "consignee_country",
    label: "Consignee Country",
  },
  {
    value: "derived_destination_city",
    label: "Consignee City",
  },
  {
    value: "derived_country",
    label: "Countries Of Origin",
  },
  {
    value: "derived_city",
    label: "Shipper Cities",
  },
  {
    value: "derived_shipment_country_of_origin",
    label: "Countries of Origin",
  },
  {
    value: "derived_shipment_country_of_exporter",
    label: "Countries of Export",
  },
  {
    value: "derived_consignee_province",
    label: "Consignee Provinces",
  },
  {
    value: "derived_consignee_city",
    label: "Consignee Cities",
  },
  {
    value: "channel_of_clearance",
    label: "Channel Of Clearances",
  },
  {
    value: "customs_office_name",
    label: "Customs Offices",
  },
  {
    value: "transportation_company_name_or_code",
    label: "Carrier",
  },
  {
    value: "terminal_name",
    label: "Terminal",
  },
  {
    value: "derived_trade_custom_office_origin_country",
    label: "Top Trade Routes (Customs Office → Country of Origin)",
  },
  {
    value: "derived_trade_custom_office_shipping_port",
    label: "Top Trade Routes (Customs Office → Port of Lading)",
  },
  {
    value: "derived_shipper_province",
    label: "Shipper Provinces",
  },
  {
    value: "shipper_province",
    label: "Shipper Provinces",
  },
  {
    value: "derived_shipper_country",
    label: "Country of Export",
  },
  {
    value: "shipper_country",
    label: "Shipper Country",
  },
  {
    value: "derived_port_of_destination_country",
    label: "Countries of Destination",
  },
  {
    value: "trade_port_origin_to_destination",
    label: "Trade Routes (Place Of Receipt → Place Of Delivery)",
  },
  {
    value: "trade_route_maritime_port",
    label: "Trade Routes (Port Of Maritime Origin → Port Of Lading → Port Of Unlading → Port Of Maritime Destination)",
  },
  {
    value: "trade_route_ship_state_port_dest",
    label: "Trade Routes (Shipper State → Place Of Delivery)",
  },
  {
    value: "trade_maritime_port",
    label: "Trade Routes (Port Of Maritime Origin → Port Of Maritime Destination)",
  },
  {
    value: "derived_consignee_country",
    label: "Countries of Import",
  },
  {
    value: "port_of_origin",
    label: "Ports of Origin",
  },
  {
    value: "derived_port_of_maritime_origin",
    label: "Ports Of Maritime Origin",
  },
  {
    value: "port_of_unlading_country",
    label: "Ports Of Unlading Countries",
  },
  {
    value: "derived_port_of_maritime_destination",
    label: "Ports Of Maritime Destination",
  },
  {
    value: "derived_port_of_maritime_destination_country_combined",
    label: "Ports of Maritime Destination",
  },
  {
    value: "derived_port_of_maritime_destination_country",
    label: "Ports of Maritime Destination Countries",
  },
  {
    value: "derived_port_of_destination",
    label: "Places Of Delivery",
  },
  {
    value: "forwarder_name",
    label: "Forwarder",
  },
  {
    value: "mode_of_transportation",
    label: "Modes Of Transportation",
  },
  {
    value: "derived_container_type_description",
    label: "Container Types",
  },
  {
    value: "derived_city_of_origin",
    label: "Places of Receipt",
  },
  {
    value: "trade_maritime_route",
    label: "Trade Routes (Port Of Maritime Origin → Port Of Lading → Port Of Unlading → Port Of Maritime Destination)",
  },
  {
    value: "trade_route_place_origin_destination",
    label: "Trade Routes (Place of Receipt → Place Of Delivery)",
  },
  {
    value: "trade_route_place_origin_destination",
    label: "Trade Routes (Place of Receipt → Place Of Delivery)",
  },
  {
    value: "trade_route_place_state",
    label: "Trade Routes (Place of Receipt → Consignee State)",
  },
  {
    value: "trade_route_place_state",
    label: "Trade Routes (Place of Receipt → Consignee State)",
  },
  {
    value: "scac_name",
    label: "Carriers",
  },
  {
    value: "derived_port_of_lading_country",
    label: "Ports Of Lading Countries",
  },
  {
    value: "city_of_destination",
    label: "Places of Delivery",
  },
  {
    value: "derived_port_of_maritime_origin_country",
    label: "Ports Of Maritime Origin Countries",
  },
  {
    value: "derived_port_of_origin",
    label: "Ports of Origin",
  },
  {
    value: "port_of_origin_country",
    label: "Ports Of Origin Countries",
  },
  {
    value: "derived_secondary_notify_parties",
    label: "Secondary Notify Parties",
  },
  {
    value: "trade_route_lading_to_unlading",
    label: "Trade Routes (Port of Lading → Port of Unlading)",
  },
  {
    value: "mode_of_transport",
    label: "Mode of Transportation",
  },
  {
    value: "port_of_arrival",
    label: "Ports of Unlading",
  },
  {
    value: "consignee_city",
    label: "Top Consignee Cities",
  },
  {
    value: "consignee_province",
    label: "Top Consignee Provinces",
  },
  {
    value: "vessel_name",
    label: "Top Vessels",
  },
  {
    value: "trade_route_export_country_to_port_of_arrival",
    label: "Top Trade Routes (Country of Export → Port of Unlading)",
  },
  {
    value: "trade_route_origin_country_to_export_country_to_port_of_arrival",
    label: "Top Trade Routes (Country of Origin → Country of Export → Port of Unlading)",
  },
  {
    value: "consignee_district",
    label: "Consignee District",
  },
  {
    value: "shipper_district",
    label: "Shipper District",
  },
  {
    value: "trade_lading_to_unlading",
    label: "Trade Routes (Port Of Lading → Port Of Unlading)",
  },
  {
    value: "trade_custom_house_to_unlading",
    label: "Trade Routes (Custom House Name → Port Of Unlading)",
  },
  {
    value: "trade_shipper_province_to_consignee_district",
    label: "Trade Routes (Shipper Province → Consignee District)",
  },
  {
    value: "trade_lading_to_consignee_country",
    label: "Trade Route (Port of Lading → Consignee Country)",
  },
  {
    value: "trade_custom_house_to_consignee_country",
    label: "Trade Routes (Custom House Name → Consignee Country)",
  },
  {
    value: "custom_house",
    label: "Customs Houses",
  },
  {
    value: "warehouse_name",
    label: "Custom Clearance Warehouses",
  },
  {
    value: "derived_freight_forwarder_name",
    label: "Forwarder Name",
  },
  {
    value: "trade_country_of_origin_to_customs_branch",
    label: "Trade Routes (Country of Origin → Custom House)",
  },
  {
    value: "trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch",
    label: "Trade Routes (Country of Origin → Port of Lading → Port of Unlading → Custom House)",
  },
  {
    value: "trade_country_of_origin_to_port_of_unlading",
    label: "Trade Routes (Country of Origin → Port of Unlading)",
  },
  {
    value: "trade_port_of_lading_to_customs_branch",
    label: "Trade Routes (Port of Lading → Custom House)",
  },
  {
    value: "trade_port_of_lading_to_port_of_unlading",
    label: "Trade Routes (Port of Lading → Port of Unlading)",
  },
  {
    value: "trade_shipper_district_to_consignee_district",
    label: "Trade Routes (Shipper District → Consignee District)",
  },
  {
    value: "derived_consignee_province_country_combined",
    label: "Consignee Provinces",
  },
  {
    value: "derived_consignee_district_country_combined",
    label: "Consignee Districts",
  },
  {
    value: "derived_port_of_unlading_country_combined",
    label: "Ports of Unlading",
  },
  {
    value: "derived_shipper_district_country_combined",
    label: "Shipper Districts",
  },
  {
    value: "derived_shipper_city_country_combined",
    label: "Shipper Cities",
  },
  {
    value: "derived_port_of_lading_country_combined",
    label: "Ports of Lading",
  },
  {
    value: "trade_route_coo_unlading",
    label: "Trade Routes (Country of Origin → Port of Unlading)",
  },
  {
    value: "trade_route_lading_unlading",
    label: "Trade Routes (Port of Lading → Port of Unlading)",
  },
  {
    value: "trade_route_coo_lading_unlading",
    label: "Trade Routes (Country of Origin → Port of Lading → Port of Unlading)",
  },
  {
    value: "trade_route_shipper_country_consignee_state",
    label: "Trade Routes (Country of Export → Consignee State)",
  },
  {
    value: "customs_house_agent_name",
    label: "Top Customs House Agent Name",
  },
  {
    value: "consignee_state",
    label: "Top Consignee States",
  },
  {
    value: "shipper_state",
    label: "Top Shipper States",
  },
  {
    value: "trade_route_lading_port_to_destination_country",
    label: "Trade Routes (Port of Lading → Country of Import)",
  },
  {
    value: "trade_route_lading_to_unlading_to_destination_country",
    label: "Trade Routes (Port of Lading → Port of Unlading → Country of Import)",
  },
  {
    value: "trade_route_shipper_state_to_destination_country",
    label: "Trade Routes (Shipper State → Country of Import)",
  },
  {
    value: "inbound_country",
    label: "Country of Import",
  },
  {
    value: "outbound_country",
    label: "Country of Export",
  },
  {
    value: "six_digit_hs_code",
    label: "Top 6 Digit HS Codes",
  },
  {
    value: "places_of_receipt",
    label: "Top Places of Receipt",
  },
  {
    value: "place_of_delivery",
    label: "Top Places of Delivery",
  },
  {
    value: "producers",
    label: "Top Producers",
  },
  {
    value: "trade_country_of_origin_to_export_to_destination",
    label: "Top Trade Routes (Country of Origin → Country of Export → Country of Import)",
  },
  {
    value: "trade_country_of_origin_to_import_to_destination",
    label: "Top Trade Routes (Country of Origin → Country of Import → Country of Destination)",
  },
  {
    value: "country_of_import",
    label: "Top Countries of Import",
  },
  {
    value: "trade_port_of_lading_to_unlading",
    label: "Top Port Pairs (Port of Lading → Port of Unlading)",
  },
  {
    value: "derived_trade_lane",
    label: "Top Trade Lanes",
  },
];

const customStyles = {
  rows: {
    style: {
      maxHeight: "48px",
      minHeight: "48px",
      borderBottom: "none !important",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderLeft: "1px solid #eaeaea",
      borderBottom: "1px solid #eaeaea",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
  },
};

const intelAPIEndpoints = {
  getanalyticsUSViewAll: getApiUrl("analytics/analyticsUSViewAll"),
  getanalyticsUSExportsViewAll: getApiUrl("analytics/analyticsUSExportsViewAll"),
  getanalyticsBrazilImportsViewAll: getApiUrl("analytics/analyticsBrazilImportsViewAll"),
  getanalyticsBrazilExportsViewAll: getApiUrl("analytics/analyticsBrazilExportsViewAll"),
  downloadExcel: getApiUrl("create_excel_analytics_view_all"),
  getanalyticsUruguayExportsViewAll: getApiUrl("analytics/uruguayExportAnalyticsViewAll"),
  getanalyticsUruguayImportsViewAll: getApiUrl("analytics/uruguayImportAnalyticsViewAll"),
  getanalyticsChileExportsViewAll: getApiUrl("analytics/chileExportAnalyticsViewAll"),
  getanalyticsColombiaExportsViewAll: getApiUrl("analytics/colombiaExportAnalyticsViewAll"),
  getanalyticsPanamaExportsViewAll: getApiUrl("analytics/panamaExportAnalyticsViewAll"),
  getanalyticsColombiaImportsViewAll: getApiUrl("analytics/colombiaImportAnalyticsViewAll"),
  getanalyticsChileImportsViewAll: getApiUrl("analytics/chileImportAnalyticsViewAll"),
  getanalyticsMexicoImportsViewAll: getApiUrl("analytics/mexicoImportAnalyticsViewAll"),
  getanalyticsMexicoExportsViewAll: getApiUrl("analytics/mexicoExportAnalyticsViewAll"),
  getanalyticsArgentinaImportViewAll: getApiUrl("analytics/argentinaImportAnalyticsViewAll"),
  getanalyticsArgentinaExportViewAll: getApiUrl("analytics/argentinaExportAnalyticsViewAll"),
  getanalyticsPanamaImportsViewAll: getApiUrl("analytics/panamaImportAnalyticsViewAll"),
  getanalyticsEcuadorImportsViewAll: getApiUrl("analytics/ecuadorImportAnalyticsViewAll"),
  getanalyticsPeruExportsViewAll: getApiUrl("analytics/peruExportAnalyticsViewAll"),
  getanalyticsPeruImportsViewAll: getApiUrl("analytics/peruImportAnalyticsViewAll"),
  getanalyticsEcuadorExportsViewAll: getApiUrl("analytics/ecuadorExportAnalyticsViewAll"),
  getanalyticsUkImportsViewAll: getApiUrl("analytics/ukImportAnalyticsViewAll"),
  getanalyticsUkExportsViewAll: getApiUrl("analytics/ukExportAnalyticsViewAll"),
  getanalyticsIndonesiaImportsViewAll: getApiUrl("analytics/indonesiaImportAnalyticsViewAll"),
  getanalyticsIndonesiaExportsViewAll: getApiUrl("analytics/indonesiaExportAnalyticsViewAll"),
};
export default class ViewAnalyticsReport extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      analyticsViewAllResponseData: [],
      analyticsViewAll_mustnot_Data: [],
      viewAllFinalSearchReqObj: {},
      isLoaderActive: false,
      viewAllPaginationOptions: {
        rowsPerPageText: "Result per page",
        paginationRowsPerPageOptions: [10, 20, 30],
      },
      viewAllCurrentPage: 1,
      totalViewAllData: 0,
      viewAllPerPage: 10,
      defaultViewAllData: [],
      showViewAllModal: false,
      defaultViewAllColumns: [],
      analyticsViewAllKey: { value: "", label: "" },
      analysisIndexKey: null,
      loading: false,
      fromCountry: "",
      selectedRows: [],
      selectedRowsPerPage: "",
      showTwoLevel: this.props.report?.is_second_level,
      twolevelData: [],
      twoLevelColumn: [],
      show: false,
      target: null,
      downloadFromValue: 1,
      downloadToValue: 100,
      showDownloadImpExpModal: false,
      defaultTwoLevelColumn: this.props.currentKeyViewTrendItem.defaultKey,
      existingReqObj: "",
      defaultPage: 1,
      valueChanged: false,
      fromData: null,
      toData: null,
      maxPaginate: 0,
      viewPerPage: 10,
      clearButton: false,
      count: 1,
      isOnSelect: false,
      search_type_options: [...this.props.dropdownOptions],
    };
  }
  componentDidMount() {
    this.setState({
      defaultViewAllData: [],
    });
    let searchRequestObj = !!this && !!this.props && !!this.props.viewAllFinalSearchReqObj ? this.props.viewAllFinalSearchReqObj : {};
    searchRequestObj.must_not = [];
    searchRequestObj.isTrends = false;
    this.findAnalysisKeyInList(!!this.props && !!this.props.viewAllFinalSearchReqObj && !!this.props.viewAllFinalSearchReqObj.analysis && this.props.viewAllFinalSearchReqObj.analysis !== "" ? this.props.viewAllFinalSearchReqObj.analysis : "");
    this.mapHeadingInModal();
    this.mapCountryFrom(!!this && !!this.props && !!this.props.from ? this.props.from : "US");
    setTimeout(() => {
      this.fetchAnalyticsViewAllData(searchRequestObj);
    }, 200);
    trademoTrackingEvents(this.getPendoKey(trackingEventDictionary.reportView), generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
  }
  getPendoKey(key) {
    return `${this.props.analyticsCountryID.toLowerCase().replace("-", "_")}${this.props?.report?.report_name?.toLowerCase().replace("top", "").replaceAll(" ", "_").replaceAll("→", "to")}_${key}`;
  }
  // Fetching analytics Data From API
  fetchAnalyticsViewAllData(searchRequestObj, paginationStr) {
    this.setState({
      showViewAllModal: true,
      isLoaderActive: true,
    });
    const apiUrl = this.props.viewAllAPI;
    if (this.state.showTwoLevel) {
      searchRequestObj.isSecondLevelAnalytics = true;
      searchRequestObj.subAnalyticsField = this.props.report.secondary_attribute_field;
    } else {
      delete searchRequestObj.isSecondLevelAnalytics;
      delete searchRequestObj.subAnalyticsField;
    }
    this.setState({
      existingReqObj: searchRequestObj,
    });

    axios.post(apiUrl, searchRequestObj).then(
      (res) => {
        if (!!res && !!res.data && !!res.data.data) {
          if (res.data.count < this.state.downloadToValue) {
            this.setState({
              downloadToValue: res.data.count,
            });
          }
          if (!this.state.showTwoLevel) {
            let tempDataArray = [...this.state.defaultViewAllData];
            this.setState({
              defaultViewAllData: tempDataArray.concat(res.data.data).map((item) => ({ ...item, s_no: item.id })),
              totalViewAllData: res.data.count || res.data.data.length,
            });
            let tempMustNotIncludeViewAllData = this.state.analyticsViewAll_mustnot_Data.concat(res.data.must_not);
            this.setState({
              analyticsViewAll_mustnot_Data: tempMustNotIncludeViewAllData,
            });
            setTimeout(() => {
              this.setState({
                isLoaderActive: false,
              });
              this.openViewAllModal();
            }, 200);
          } else {
            if (this.state.defaultViewAllColumns.length) {
              if (paginationStr) {
                let tempDataArray = [...this.state.twolevelData];
                this.setState({
                  twolevelData: tempDataArray.concat(res.data.data),
                  show: false,
                });
                let tempMustNotIncludeViewAllData = this.state.analyticsViewAll_mustnot_Data.concat(res.data.must_not);
                this.setState({
                  analyticsViewAll_mustnot_Data: tempMustNotIncludeViewAllData,
                });
              } else {
                this.setState({
                  twolevelData: res.data.data,
                  show: false,
                });
                let tempMustNotIncludeViewAllData = this.state.analyticsViewAll_mustnot_Data.concat(res.data.must_not);
                this.setState({
                  analyticsViewAll_mustnot_Data: tempMustNotIncludeViewAllData,
                });
              }

              setTimeout(() => {
                this.openViewAllModal();
                this.setState({
                  isLoaderActive: false,
                });
              }, 500);
            }
          }
        }
      },
      () => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    );
  }

  handleClick = (event) => {
    event.stopPropagation();
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletViewAll2ndLevelAnalyticsAttribute, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    this.setState({
      show: !this.state.show,
    });
    setTimeout(() => {
      this.openViewAllModal();
    }, 100);
  };
  // End of above code
  bindGroupByResultValue(data, paginationStr) {
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletViewAllSortBy, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    let searchRequestObj = !!this && !!this.props && !!this.props.viewAllFinalSearchReqObj ? this.props.viewAllFinalSearchReqObj : {};
    if (!!data && data !== "") {
      searchRequestObj.analysis = data;
      this.findAnalysisKeyInList(data);
    }
    if (!!paginationStr && paginationStr !== "") {
      searchRequestObj.must_not = this.state.analyticsViewAll_mustnot_Data;
    } else {
      this.setState({
        defaultViewAllData: [],
        analyticsViewAll_mustnot_Data: [],
        viewAllCurrentPage: 1,
        selectedRows: [],
        isLoaderActive: true,
      });
      searchRequestObj.must_not = [];
    }
    this.fetchAnalyticsViewAllData(searchRequestObj);
    this.openViewAllModal();
  }

  gridSizeHandler = (row) => {
    if (row?.field4) {
      return "25%";
    } else if (row?.field3) {
      return "33%";
    } else if (row?.field2) {
      return "50%";
    } else if (row?.field1) {
      return "100%";
    } else {
      return "50%";
    }
  };

  openViewAllModal() {
    let defaultViewAllColumnsClone = [
      {
        omit: this.state.showTwoLevel,
        name: "S No.",
        selector: "id",
        key: "id",
        sortable: false,
        grow: 0,
      },
      {
        omit: (!!this && !!this.state && !!this.state.defaultViewAllData && this.state.defaultViewAllData.length > 0 && !!this.state.defaultViewAllData[0].key && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "HS Codes" && (!this.state.analyticsViewAllKey.label.toLowerCase().includes("hs code") || this.state.analyticsViewAllKey.label === "Top 6 Digit HS Codes") && this.state.analyticsViewAllKey.label !== "2 digit HS Codes") || (!!this && !!this.state && !!this.state.twolevelData && this.state.twolevelData.length > 0 && !!this.state.twolevelData[0].key) ? false : true,
        name: (
          <div className="d-flex align-items-center">
            {!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== ""
              ? !!this && !!this.props && !!this.props.from && this.props.from === "MEXICO-EXPORTS" && this.state.analyticsViewAllKey.label === "Countries of Origin"
                ? "Countries of Destination"
                : !!this && !!this.props && !!this.props.from && this.props.from === "MEXICO-EXPORTS" && this.state.analyticsViewAllKey.label === "Consignee States"
                  ? "Shipper States"
                  : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-EXPORTS" && this.state.analyticsViewAllKey.value === "derived_port_of_destination_country"
                    ? "Place Of Delivery Country"
                    : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-EXPORTS" && this.state.analyticsViewAllKey.value === "port_of_origin"
                      ? "Places Of Receipt"
                      : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-IMPORTS" && this.state.analyticsViewAllKey.value === "derived_country_of_origin"
                        ? "Place Of Receipt Country"
                        : !!this && !!this.props && !!this.props.from && this.props.from === "URUGUAY-IMPORTS" && this.state.analyticsViewAllKey.value === "derived_custom_office_entry_name"
                          ? "Customs Offices"
                          : this.state.analyticsViewAllKey.value === "derived_country_of_provenance_english"
                            ? "Country of Export"
                            : !!this && !!this.props && !!this.props.from && (this.props.from === "RUSSIA-IMPORTS" || this.props.from === "RUSSIA-EXPORTS") && getFirstColNameForRussia(this.state.analyticsViewAllKey)?.length > 0
                              ? getFirstColNameForRussia(this.state.analyticsViewAllKey)
                              : this.state.analyticsViewAllKey.label
              : "Data"}
          </div>
        ),
        key: "key",
        sortable: false,
        grow: 1,
        selector: (row) => (
          <div className="text-capitalize" data-tip={!!row.key && row.key !== "" && row.key.length > 20 ? row.key : ""} data-for="first">
            {this.state.showTwoLevel ? (
              <div>
                {row.s_no === 1 ? (
                  <div className="twolevelkeyContainer">
                    <div className="text-left">
                      {!!row.key && row.key !== "" && typeof row.key === "string" ? <span>{row.key.slice(0, 20).toLowerCase()}</span> : ""}
                      {!!row.key && row.key !== "" && row.key.length > 20 ? <span>...</span> : <></>}
                    </div>
                    <div className="text-left total_count_twolevl">{!!this.state.search_type_options[this.state.analysisIndexKey] && this.state.search_type_options[this.state.analysisIndexKey].two_table_header ? this.state.search_type_options[this.state.analysisIndexKey].two_table_header : this.state.search_type_options[0].value}</div>
                    <div className="total_count_twolevl">( {this.state.showTwoLevel && !!row.total ? commaFormat(row.total) : "NA"} ) </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div>
                <div className="text-left">
                  {!!row.key && row.key !== "" && typeof row.key === "string" ? <span>{row.key.slice(0, 20).toLowerCase()}</span> : ""}
                  {!!row.key && row.key !== "" && row.key.length > 20 ? <span>...</span> : <></>}
                </div>
                <div>{this.state.showTwoLevel && !!row.total ? row.total : ""}</div>
              </div>
            )}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="first" />
          </div>
        ),
      },
      {
        omit: !!this && !!this.state && !!this.state.defaultViewAllData && this.state.defaultViewAllData.length > 0 && !!this.state.defaultViewAllData[0].description && !this.state.showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" ? this.state.analyticsViewAllKey.label : "Data"} </div>,
        sortable: false,
        key: "description",
        grow: 2,
        selector: (row) => (
          <div className="text-capitalize" data-tip={!!row.description && row.description !== "" && row.description.length > 30 ? row.description : ""} data-for="second">
            {!!row.description && row.description !== "" ? <span>{row.description.slice(0, 30).toLowerCase()}</span> : ""}
            {!!row.description && row.description !== "" && row.description.length > 30 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="second" />
          </div>
        ),
      },
      {
        omit: !!this && !!this.state && !!this.state.defaultViewAllData && this.state.defaultViewAllData.length > 0 && !!this.state.defaultViewAllData[0].field1 && !this.state.showTwoLevel ? false : true,
        name: (
          <div className="d-flex align-items-center">
            {!!this && !!this.props && !!this.props.from && this.props.from === "US-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Port of Lading" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Shipper State" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port Of Lading" : this.state.analyticsViewAllKey.value === "trade_maritime_port" ? "Port Of Maritime Origin" : this.state.analyticsViewAllKey.value === "trade_route_ship_state_port_dest" ? "Shipper State" : this.state.analyticsViewAllKey.value === "trade_route_maritime_port" ? "Port Of Maritime Origin" : this.state.analyticsViewAllKey.value === "trade_port_origin_to_destination" ? "Place Of Receipt" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "URUGUAY-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Port of Lading" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Customs Offices" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "URUGUAY-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Country of Origin" : this.state.analyticsViewAllKey.value === "trade_country" ? "Customs Offices" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port Of Lading" : this.state.analyticsViewAllKey.value === "trade_maritime_port" ? "Port Of Maritime Origin" : this.state.analyticsViewAllKey.value === "trade_route_place_state" ? "Place of Receipt" : this.state.analyticsViewAllKey.value === "trade_route_place_origin_destination" ? "Place of Receipt" : this.state.analyticsViewAllKey.value === "trade_maritime_route" ? "Port Of Maritime Origin" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "MEXICO-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Country of Origin" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Country of Origin" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "MEXICO-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Customs Houses" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Mexico State of Shipper" : this.state.analyticsViewAllKey.label === "Countries of Origin" ? "Country of Destination" : this.state.analyticsViewAllKey.label === "Consignee States" ? "Shipper States" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "CHILE-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Foreign Port of Lading" : this.state.analyticsViewAllKey.label === "Trade Origin Country" ? "Country of Origin" : this.state.analyticsViewAllKey.label === "Trade Purchase Country" ? "Country of Purchase" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "CHILE-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Port of Lading" : this.state.analyticsViewAllKey.label === "Trade City Country" ? "Shipper City" : this.state.analyticsViewAllKey.label === "Trade Port Country" ? "Port of Lading" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "COLOMBIA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_origin_country_destination_state" ? "Country of Origin" : this.state.analyticsViewAllKey.value === "trade_export_country_destination_state" ? "Country of Export" : this.state.analyticsViewAllKey.value === "trade_origin_export_country_destination_state" ? "Country of Origin" : this.state.analyticsViewAllKey.value === "trade_exporter_city_destination_state" ? "Shipper City" : this.state.analyticsViewAllKey.value === "trade_exporter_city_importer_state" ? "Shipper City" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "COLOMBIA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_origin_state_destination_country" ? "State of Origin" : this.state.analyticsViewAllKey.value === "trade_export_state_destination_country" ? "State of Export" : this.state.analyticsViewAllKey.value === "trade_origin_export_state_departure_destination" ? "State of Origin" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PANAMA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port_origin_country" ? "Country of Origin" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PANAMA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port_destination_country" ? "Port of Lading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "ARGENTINA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_custom_destination_country" ? "Customs Houses" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PERU-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_customs_destination_country" ? "Customs Houses" : this.state.analyticsViewAllKey.value === "trade_customs_port" ? "Customs Houses" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PERU-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "derived_trade_custom_office_origin_country" ? "Country of Origin" : this.state.analyticsViewAllKey.value === "derived_trade_custom_office_shipping_port" ? "Foreign Shipping Port" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "ECUADOR-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "derived_country_of_origin_port_of_lading_country_country_of_export" ? "Country of Origin" : this.state.analyticsViewAllKey.value === "derived_port_of_lading_port_of_lading_country_customs_house_name" ? "Port of Lading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "ECUADOR-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "derived_customs_house_name_country_of_destination" ? "Customs Houses" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "INDONESIA-IMPORTS" || this.props.from === "INDONESIA-NM-IMPORTS") ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port of Lading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "INDONESIA-EXPORTS" || this.props.from === "INDONESIA-NM-EXPORTS") ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port of Lading " : this.state.analyticsViewAllKey.value === "trade_country" ? "Shipper Province" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PHILIPPINES-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_export_country_to_port_of_arrival" ? "Country of Export" : this.state.analyticsViewAllKey.value === "trade_route_origin_country_to_export_country_to_port_of_arrival" ? "Country of Origin" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "VIETNAM-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_customs_branch" || this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_port_of_unlading" || this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch") ? "Country of Origin" : this.state.analyticsViewAllKey.value === "trade_port_of_lading_to_customs_branch" || this.state.analyticsViewAllKey.value === "trade_port_of_lading_to_port_of_unlading" ? "Port of Lading" : this.state.analyticsViewAllKey.value === "trade_shipper_district_to_consignee_district" ? "Shipper District" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "VIETNAM-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_custom_house_to_consignee_country" || this.state.analyticsViewAllKey.value === "trade_custom_house_to_unlading") ? "Custom Houses" : this.state.analyticsViewAllKey.value === "trade_lading_to_consignee_country" || this.state.analyticsViewAllKey.value === "trade_lading_to_unlading" ? "Port of Lading" : this.state.analyticsViewAllKey.value === "trade_shipper_province_to_consignee_district" ? "Shipper Province" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "INDIA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_route_coo_lading_unlading" || this.state.analyticsViewAllKey.value === "trade_route_coo_unlading") ? "Country of Origin" : this.state.analyticsViewAllKey.value === "trade_route_lading_unlading" ? "Port of Lading" : this.state.analyticsViewAllKey.value === "trade_route_shipper_country_consignee_state" ? "Shipper Country" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "INDIA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_route_lading_port_to_destination_country" || this.state.analyticsViewAllKey.value === "trade_route_lading_to_unlading" || this.state.analyticsViewAllKey.value === "trade_route_lading_to_unlading_to_destination_country") ? "Port of Lading" : this.state.analyticsViewAllKey.value === "trade_route_shipper_state_to_destination_country" ? "Shipper State" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "RUSSIA-IMPORTS" || this.props.from === "RUSSIA-EXPORTS") ? (
              getFirstColNameForRussia(this.state.analyticsViewAllKey)
            ) : (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Ports of Unlading" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Shipper Country" : this.state.analyticsViewAllKey.label}</>
            )}
          </div>
        ),
        key: "field1",
        sortable: false,
        grow: 2,
        selector: (row) => (
          <div className="text-capitalize" data-tip={!!row.field1 && row.field1 !== "" && row.field1.length > 13 ? row.field1 : ""} data-for="third">
            {!!row.field1 && row.field1 !== "" ? <span>{row.field1.slice(0, 30).toLowerCase()}</span> : ""}
            {!!row.field1 && row.field1 !== "" && row.field1.length > 30 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="third" />
          </div>
        ),
      },
      {
        omit: !!this && !!this.state && !!this.state.defaultViewAllData && this.state.defaultViewAllData.length > 0 && !!this.state.defaultViewAllData[0].field2 && !this.state.showTwoLevel ? false : true,
        name: (
          <div className="d-flex align-items-center">
            {!!this && !!this.props && !!this.props.from && this.props.from === "US-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Port of Unlading" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Country of Destination" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port Of Unlading" : this.state.analyticsViewAllKey.value === "trade_maritime_port" ? "Port Of Maritime Destination" : this.state.analyticsViewAllKey.value === "trade_route_ship_state_port_dest" ? "Place Of Delivery" : this.state.analyticsViewAllKey.value === "trade_route_maritime_port" ? "Port Of Lading" : this.state.analyticsViewAllKey.value === "trade_port_origin_to_destination" ? "Place Of Delivery" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "URUGUAY-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Port of Unlading" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Country" : this.state.analyticsViewAllKey.label === "Countries of Destination" ? "Country of Destination" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "URUGUAY-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Country of Export" : this.state.analyticsViewAllKey.value === "trade_country" ? "Country of Origin" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port Of Unlading" : this.state.analyticsViewAllKey.value === "trade_maritime_port" ? "Port Of Maritime Destination" : this.state.analyticsViewAllKey.value === "trade_route_place_state" ? "Consignee State" : this.state.analyticsViewAllKey.value === "trade_route_place_origin_destination" ? " Place Of Delivery" : this.state.analyticsViewAllKey.value === "trade_maritime_route" ? "Port Of Lading" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "MEXICO-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Customs Houses" : this.state.analyticsViewAllKey.label === "Trade Country" ? "State of Consignee" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "MEXICO-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Country of Destination" : this.state.analyticsViewAllKey.label === "Trade Country" ? "Country of Destination" : this.state.analyticsViewAllKey.label === "Countries of Origin" ? "Country of Destination" : this.state.analyticsViewAllKey.label === "Consignee States" ? "Shipper States" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "CHILE-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Port of Unlading" : this.state.analyticsViewAllKey.label === "Trade Origin Country" ? "Port of Unlading" : this.state.analyticsViewAllKey.label === "Trade Purchase Country" ? "Port of Unlading" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "CHILE-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Foreign Port of Unlading" : this.state.analyticsViewAllKey.label === "Trade City Country" ? "Country of Destination" : this.state.analyticsViewAllKey.label === "Trade Port Country" ? "Country of Destination" : this.state.analyticsViewAllKey.label}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "COLOMBIA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_origin_country_destination_state" ? "Destination State" : this.state.analyticsViewAllKey.value === "trade_export_country_destination_state" ? "Destination State" : this.state.analyticsViewAllKey.value === "trade_origin_export_country_destination_state" ? "Country of Export" : this.state.analyticsViewAllKey.value === "trade_exporter_city_destination_state" ? "Destination State" : this.state.analyticsViewAllKey.value === "trade_exporter_city_importer_state" ? "Consignee State" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "COLOMBIA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_origin_state_destination_country" ? "Country of Destination" : this.state.analyticsViewAllKey.value === "trade_export_state_destination_country" ? "Country of Destination" : this.state.analyticsViewAllKey.value === "trade_origin_export_state_departure_destination" ? "State of Export" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PANAMA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port_origin_country" ? "Port of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PANAMA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port_destination_country" ? "Country of Destination" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "ARGENTINA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_custom_destination_country" ? "Country of Import" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PERU-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_customs_destination_country" ? "Country of Destination" : this.state.analyticsViewAllKey.value === "trade_customs_port" ? "Port of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PERU-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "derived_trade_custom_office_origin_country" ? "Customs Offices" : this.state.analyticsViewAllKey.value === "derived_trade_custom_office_shipping_port" ? "Customs Office" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "ECUADOR-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "derived_country_of_origin_port_of_lading_country_country_of_export" ? "Port of Lading Country" : this.state.analyticsViewAllKey.value === "derived_port_of_lading_port_of_lading_country_customs_house_name" ? "Customs Houses" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "ECUADOR-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "derived_customs_house_name_country_of_destination" ? "Country of Import" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "INDONESIA-IMPORTS" || this.props.from === "INDONESIA-NM-IMPORTS") ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port of Unlading " : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "INDONESIA-EXPORTS" || this.props.from === "INDONESIA-NM-EXPORTS") ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Port of Unlading " : this.state.analyticsViewAllKey.value === "trade_country" ? "Country of Destination" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PHILIPPINES-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_export_country_to_port_of_arrival" ? "Port of Unlading " : this.state.analyticsViewAllKey.value === "trade_route_origin_country_to_export_country_to_port_of_arrival" ? "Country of Export" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "VIETNAM-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_port_of_lading_to_customs_branch" || this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_customs_branch") ? "Customs House" : this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_port_of_unlading" || this.state.analyticsViewAllKey.value === "trade_port_of_lading_to_port_of_unlading" ? "Port of Unlading" : this.state.analyticsViewAllKey.value === "trade_shipper_district_to_consignee_district" ? "Consignee District" : this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch" ? "Post of Lading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "VIETNAM-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_custom_house_to_consignee_country" || this.state.analyticsViewAllKey.value === "trade_lading_to_consignee_country") ? "Consignee Country" : this.state.analyticsViewAllKey.value === "trade_custom_house_to_unlading" || this.state.analyticsViewAllKey.value === "trade_lading_to_unlading" ? "Port of Unlading" : this.state.analyticsViewAllKey.value === "trade_shipper_province_to_consignee_district" ? "Consignee District" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "INDIA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_route_coo_unlading" || this.state.analyticsViewAllKey.value === "trade_route_lading_unlading") ? "Port of Unlading" : this.state.analyticsViewAllKey.value === "trade_route_coo_lading_unlading" ? "Port of Lading" : this.state.analyticsViewAllKey.value === "trade_route_shipper_country_consignee_state" ? "Consignee State" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "INDIA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && (this.state.analyticsViewAllKey.value === "trade_route_lading_to_unlading" || this.state.analyticsViewAllKey.value === "trade_route_lading_to_unlading_to_destination_country") ? "Port of Unlading" : this.state.analyticsViewAllKey.value === "trade_route_lading_port_to_destination_country" || this.state.analyticsViewAllKey.value === "trade_route_shipper_state_to_destination_country" ? "Country of Destination" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "RUSSIA-IMPORTS" || this.props.from === "RUSSIA-EXPORTS") ? (
              getSecondColNameForRussia(this.state.analyticsViewAllKey)
            ) : (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.label && this.state.analyticsViewAllKey.label !== "" && this.state.analyticsViewAllKey.label === "Trade Port" ? "Ports of Unlading" : this.state.analyticsViewAllKey.label === "Trade Country" ? "State of Import" : this.state.analyticsViewAllKey.label}</>
            )}
          </div>
        ),
        key: "field2",
        sortable: false,
        grow: 2,
        selector: (row) => (
          <div className="text-capitalize" data-tip={!!row.field2 && row.field2 !== "" && row.field2.length > 13 ? row.field2 : ""} data-for="fourth">
            {!!row.field2 && row.field2 !== "" ? <span>{row.field2.slice(0, 30).toLowerCase()}</span> : ""}
            {!!row.field2 && row.field2 !== "" && row.field2.length > 30 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="fourth" />
          </div>
        ),
      },
      {
        omit: !!this && !!this.state && !!this.state.defaultViewAllData && this.state.defaultViewAllData.length > 0 && !!this.state.defaultViewAllData[0].field3 && !this.state.showTwoLevel ? false : true,
        name: (
          <div className="d-flex align-items-center">
            {!!this && !!this.props && !!this.props.from && this.props.from === "URUGUAY-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_port" ? "Customs Office" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_maritime_port" ? "Port Of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_maritime_route" ? "Port Of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "PHILIPPINES-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_origin_country_to_export_country_to_port_of_arrival" ? "Port of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "VIETNAM-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch" ? "Post of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "INDIA-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_coo_lading_unlading" ? "Port of Unlading" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "INDIA-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_lading_to_unlading_to_destination_country" ? "Country of Destination" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && (this.props.from === "RUSSIA-IMPORTS" || this.props.from === "RUSSIA-EXPORTS") ? (
              getThirdColNameForRussia(this.state.analyticsViewAllKey)
            ) : !!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value === "trade_origin_export_country_destination_state" ? (
              "Destination State"
            ) : !!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value === "trade_origin_export_state_departure_destination" ? (
              "Place of Departure"
            ) : !!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value === "derived_country_of_origin_port_of_lading_country_country_of_export" ? (
              "Country of Export"
            ) : this.state.analyticsViewAllKey.label ? (
              this.state.analyticsViewAllKey.label
            ) : (
              "Data"
            )}
          </div>
        ),
        sortable: false,
        key: "field3",
        grow: 2,
        selector: (row) => (
          <div className="text-capitalize" data-tip={!!row.field3 && row.field3 !== "" && row.field3.length > 18 ? row.field3 : ""} data-for="fourth">
            {!!row.field3 && row.field3 !== "" ? <span>{row.field3.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field3 && row.field3 !== "" && row.field3.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="fourth" />
          </div>
        ),
      },
      {
        omit: !!this && !!this.state && !!this.state.defaultViewAllData && this.state.defaultViewAllData.length > 0 && !!this.state.defaultViewAllData[0].field4 && !(this.props.from === "COLOMBIA-IMPORTS") && !this.state.showTwoLevel ? false : true,
        name: (
          <div className="d-flex align-items-center">
            {!!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-EXPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_route_maritime_port" ? "Port Of Maritime Destination" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "BRAZIL-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_maritime_route" ? "Port Of Maritime Destination" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this && !!this.props && !!this.props.from && this.props.from === "VIETNAM-IMPORTS" ? (
              <>{!!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value !== "" && this.state.analyticsViewAllKey.value === "trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch" ? "Customs House" : this.state.analyticsViewAllKey.label ? this.state.analyticsViewAllKey.label : "Data"}</>
            ) : !!this.state.analyticsViewAllKey && !!this.state.analyticsViewAllKey.value && this.state.analyticsViewAllKey.value === "trade_origin_export_state_departure_destination" ? (
              "Country of Destination"
            ) : this.state.analyticsViewAllKey.label ? (
              this.state.analyticsViewAllKey.label
            ) : (
              "Data"
            )}
          </div>
        ),
        key: "field4",
        sortable: false,
        grow: 2,
        selector: (row) => (
          <div className="text-capitalize" data-tip={!!row.field4 && row.field4 !== "" && row.field4.length > 18 ? row.field4 : ""} data-for="fourth">
            {!!row.field4 && row.field4 !== "" ? <span>{row.field4.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field4 && row.field4 !== "" && row.field4.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="fourth" />
          </div>
        ),
      },
      {
        omit: !(this.state.showTwoLevel && !!this && !!this.state && !!this.state.twolevelData && !!this.state.twolevelData && !!this.state.twolevelData.length && (!!this.state.twolevelData[0].field1 || !!this.state.twolevelData[0].field2 || !!this.state.twolevelData[0].field3 || !!this.state.twolevelData[0].field4)),
        name: <div>{this.props.currentKeyViewTrendItem.label ? this.props.currentKeyViewTrendItem.label.replace("", "") : ""}</div>,
        sortable: false,
        key: "field1",
        grow: 3,
        selector: (row) => (
          <div className="text-capitalize">
            {row.s_no === 1 ? (
              <div className="position-relative">
                <div data-for="trade-route" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                  {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 100
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 100) + "..."
                      : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                    : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 100
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 100) + "..."
                        : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                        ? (row.field1 + " → " + row.field2).length > 100
                          ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 100) + "..."
                          : (row.field1 + " → " + row.field2).toUpperCase()
                        : !!row && !!row.field1 && typeof row.field1 === "string"
                          ? row.field1.toUpperCase()
                          : ""}
                </div>
                <div className="text-left total_count_twolevl">{this.state.search_type_options[this.state.analysisIndexKey] ? this.state.search_type_options[this.state.analysisIndexKey].two_table_header : this.state.search_type_options[0].value}</div>
                <div className="total_count_twolevl">( {this.state.showTwoLevel && !!row.total ? (commaFormat(row.total) ? (row.total_value ? commaFormat(row.total_value) : "") : "") : ""} ) </div>
              </div>
            ) : (
              ""
            )}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="trade-route" />
          </div>
        ),
      },
      {
        omit: !this.state.showTwoLevel,
        key: "subKey",
        name: (
          <div className="position-relative" ref={this.ref}>
            <div className="cursor-pointer" onClick={(e) => this.handleClick(e)}>
              <span>{this.props.twoColumnMapping ? this.props.twoColumnMapping[this.state.defaultTwoLevelColumn] : ""}</span>
            </div>
            {this.state.show ? (
              <div className="position-absolute twoLevelPopOver">
                {Object.keys(this.props.twoColumnMapping).map((item) =>
                  item !== this.props.currentKeyViewTrendItem.key ? (
                    <div
                      key={item}
                      onClick={() => {
                        this.selectTypeHandler(item);
                      }}
                      className={`px-2 twolevel_option_icons py-2 mt-1 cursor-pointer ${item === this.state.defaultTwoLevelColumn ? " twolevel_option_icons-selected" : ""}`}>
                      <p className={`d-flex justify-content-between m-0 `}>
                        <span className="cursor-pointer">{item !== this.props.currentKeyViewTrendItem.key ? this.props.twoColumnMapping[item] : ""}</span>
                        <span>{item === this.state.defaultTwoLevelColumn ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                      </p>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        ),
        sortable: false,
        grow: 3,
        selector: (row) => (
          <div ref={this.ref} className="text-capitalize">
            <p data-tip={row.subKey} data-for="sub-key" className={`m-0 d-flex align-items-center ${row.subKey ? "h-100" : ""}`}>
              {row.subKey ? row.subKey.slice(0, 60) : ""}
              {!!row.subKey && row.subKey.length > 60 ? "..." : ""}
            </p>
            {this.state.valueChanged ? (
              <div className="position-relative">
                <div data-for="sub-key1" data-tip={(!!row.subFields1 && typeof row.subFields1 === "string" ? row.subFields1.toUpperCase() : "") + (!!row.subFields2 && typeof row.subFields2 === "string" ? " → " + row.subFields2.toUpperCase() : "") + (!!row.subFields3 && typeof row.subFields3 === "string" ? " → " + row.subFields3.toUpperCase() : "") + (!!row.subFields4 && typeof row.subFields4 === "string" ? " → " + row.subFields4.toUpperCase() : "")} className="d-flex">
                  {!!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string" && !!row.subFields3 && typeof row.subFields3 === "string" && !!row.subFields4 && typeof row.subFields4 === "string"
                    ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).length > 110
                      ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).toUpperCase().slice(0, 110) + "..."
                      : (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).toUpperCase()
                    : !!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string" && !!row.subFields3 && typeof row.subFields3 === "string"
                      ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).length > 110
                        ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).toUpperCase().slice(0, 110) + "..."
                        : (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).toUpperCase()
                      : !!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string"
                        ? (row.subFields1 + " → " + row.subFields2).length > 110
                          ? (row.subFields1 + " → " + row.subFields2).toUpperCase().slice(0, 110) + "..."
                          : (row.subFields1 + " → " + row.subFields2).toUpperCase()
                        : !!row && !!row.subFields1 && typeof row.subFields1 === "string"
                          ? row.subFields1.toUpperCase()
                          : ""}
                </div>
              </div>
            ) : (
              ""
            )}
            <ReactTooltip
              getContent={[
                (dataTip) => {
                  return (
                    <span>
                      {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                      {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                      {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                    </span>
                  );
                },
                100,
              ]}
              className="trademo-tooltip"
              backgroundColor="#8C8C8C"
              textColor="#FFFFFF"
              place="top"
              id="sub-key"
            />
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
          </div>
        ),
      },
      {
        name: <div className="d-flex align-items-center">{this.state.analysisIndexKey !== null && !!this.state.search_type_options[this.state.analysisIndexKey].value && this.state.search_type_options[this.state.analysisIndexKey].value !== "" && this.state.search_type_options[this.state.analysisIndexKey].value === "shipments" ? <span className="font-weight-bold">Shipments</span> : <span>Shipments</span>}</div>,
        key: "shipments",
        sortable: false,
        grow: 1,
        selector: (row) => <span>{!!row.shipments && row.shipments !== "" ? getInternationalNumberSystem(row.shipments) : "NA"}</span>,
      },
      {
        omit: !!this.state && !!this.state.fromCountry && (this.state.fromCountry === "MEXICO-IMPORTS" || this.state.fromCountry === "MEXICO-EXPORTS" || this.state.fromCountry === "ARGENTINA-IMPORTS" || this.state.fromCountry === "ARGENTINA-EXPORTS" || this.props.from === "PERU-EXPORTS" || this.props.from === "UK-IMPORTS" || this.props.from === "UK-EXPORTS" || this.props.from === "VIETNAM-IMPORTS" || this.props.from === "VIETNAM-EXPORTS" || this.props.from === "INDIA-IMPORTS" || this.props.from === "INDIA-EXPORTS") ? true : false,
        name: <div className="d-flex align-items-center">{!!this.state.analysisIndexKey && !!this.state.search_type_options[this.state.analysisIndexKey].value && this.state.search_type_options[this.state.analysisIndexKey].value !== "" && this.state.search_type_options[this.state.analysisIndexKey].value === "weight" ? <span className="font-weight-bold">Weight (kg)</span> : <span>Weight (kg)</span>}</div>,
        key: "weight",
        sortable: false,
        grow: 1,
        selector: (row) => <span>{!!row.weight && row.weight !== "" ? getInternationalNumberSystem(row.weight) : "NA"}</span>,
      },
      {
        omit:
          !!this &&
          !!this.props &&
          !!this.props.from &&
          (this.state.fromCountry === "MEXICO-IMPORTS" ||
            this.state.fromCountry === "MEXICO-EXPORTS" ||
            this.props.from === "URUGUAY-EXPORTS" ||
            this.props.from === "URUGUAY-IMPORTS" ||
            this.props.from === "CHILE-IMPORTS" ||
            this.props.from === "CHILE-EXPORTS" ||
            this.props.from === "COLOMBIA-IMPORTS" ||
            this.props.from === "COLOMBIA-EXPORTS" ||
            this.state.fromCountry === "ARGENTINA-IMPORTS" ||
            this.state.fromCountry === "ARGENTINA-EXPORTS" ||
            this.props.from === "PANAMA-IMPORTS" ||
            this.props.from === "PANAMA-EXPORTS" ||
            this.props.from === "ECUADOR-IMPORTS" ||
            this.props.from === "ECUADOR-EXPORTS" ||
            this.props.from === "PERU-EXPORTS" ||
            this.props.from === "PERU-IMPORTS" ||
            this.props.from === "UK-IMPORTS" ||
            this.props.from === "UK-EXPORTS" ||
            this.props.from === "INDONESIA-EXPORTS" ||
            this.props.from === "INDONESIA-NM-EXPORTS" ||
            this.props.from === "INDONESIA-IMPORTS" ||
            this.props.from === "INDONESIA-NM-IMPORTS" ||
            this.props.from === "MULTICOUNTRY-IMPORTS" ||
            this.props.from === "PHILIPPINES-IMPORTS" ||
            this.props.from === "PHILIPPINES-EXPORTS" ||
            this.props.from === "VIETNAM-IMPORTS" ||
            this.props.from === "VIETNAM-EXPORTS" ||
            this.props.from === "INDIA-IMPORTS" ||
            this.props.from === "INDIA-EXPORTS" ||
            this.props.from === "RUSSIA-IMPORTS" ||
            this.props.from === "RUSSIA-EXPORTS")
            ? true
            : false,
        name: <div className="d-flex align-items-center">{!!this.state.analysisIndexKey && !!this.state.search_type_options[this.state.analysisIndexKey].value && this.state.search_type_options[this.state.analysisIndexKey].value !== "" && this.state.search_type_options[this.state.analysisIndexKey].value === "teu" ? <span className="font-weight-bold">TEUs</span> : <span>TEUs</span>}</div>,
        key: "teu",
        sortable: false,
        grow: 1,
        selector: (row) => <span>{!!row.teu && row.teu !== "" ? getInternationalNumberSystem(row.teu) : "NA"}</span>,
      },
      {
        omit:
          !!this &&
          !!this.props &&
          !!this.props.from &&
          (this.props.from === "US-IMPORTS" ||
            this.props.from === "US-EXPORTS" ||
            this.props.from === "CHILE-IMPORTS" ||
            this.props.from === "CHILE-EXPORTS" ||
            this.props.from === "COLOMBIA-IMPORTS" ||
            this.props.from === "COLOMBIA-EXPORTS" ||
            this.state.fromCountry === "ARGENTINA-IMPORTS" ||
            this.state.fromCountry === "ARGENTINA-EXPORTS" ||
            this.props.from === "PANAMA-IMPORTS" ||
            this.state.fromCountry === "PANAMA-EXPORTS" ||
            this.state.fromCountry === "URUGUAY-EXPORTS" ||
            this.state.fromCountry === "URUGUAY-IMPORTS" ||
            this.props.from === "ECUADOR-IMPORTS" ||
            this.props.from === "ECUADOR-EXPORTS" ||
            this.props.from === "PERU-EXPORTS" ||
            this.props.from === "PERU-IMPORTS" ||
            this.props.from === "INDONESIA-EXPORTS" ||
            this.props.from === "INDONESIA-NM-EXPORTS" ||
            this.props.from === "INDONESIA-IMPORTS" ||
            this.props.from === "INDONESIA-NM-IMPORTS" ||
            this.props.from === "MULTICOUNTRY-IMPORTS" ||
            this.props.from === "PHILIPPINES-IMPORTS" ||
            this.props.from === "PHILIPPINES-EXPORTS" ||
            this.props.from === "VIETNAM-IMPORTS" ||
            this.props.from === "VIETNAM-EXPORTS" ||
            this.props.from === "INDIA-IMPORTS" ||
            this.props.from === "INDIA-EXPORTS" ||
            this.props.from === "MEXICO-EXPORTS" ||
            this.props.from === "MEXICO-IMPORTS")
            ? false
            : true,
        name: <div className="d-flex align-items-center">{!!this.state.analysisIndexKey && !!this.state.search_type_options[this.state.analysisIndexKey].value && this.state.search_type_options[this.state.analysisIndexKey].value !== "" && this.state.search_type_options[this.state.analysisIndexKey].value === "value" ? <span className="font-weight-bold">Value (USD)</span> : <span>Value (USD)</span>}</div>,
        key: "value",
        sortable: false,
        grow: 1,
        selector: (row) => <span>{!!row.value && row.value !== "" ? getInternationalNumberSystem(row.value) : "NA"}</span>,
      },
      {
        omit: !!this && !!this.props && !!this.props.from && (this.props.from === "RUSSIA-IMPORTS" || this.props.from === "RUSSIA-EXPORTS") ? false : true,
        name: <div className="d-flex align-items-center">{!!this.state.analysisIndexKey && !!this.state.search_type_options[this.state.analysisIndexKey].value && this.state.search_type_options[this.state.analysisIndexKey].value !== "" && this.state.search_type_options[this.state.analysisIndexKey].value === "value" ? <span className="font-weight-bold">Shipment Value (USD)</span> : <span>Shipment Value (USD)</span>}</div>,
        key: "value",
        sortable: false,
        grow: 1,
        selector: (row) => <span>{!!row.value && row.value !== "" ? getInternationalNumberSystem(row.value) : "NA"}</span>,
      },
      {
        name: <div className="d-flex align-items-center">{!!this.state.analysisIndexKey && !!this.state.search_type_options[this.state.analysisIndexKey].value && this.state.search_type_options[this.state.analysisIndexKey].value !== "" && (this.state.search_type_options[this.state.analysisIndexKey].value === "shipments_percentage" || this.state.search_type_options[this.state.analysisIndexKey].value === "weight_percentage" || this.state.search_type_options[this.state.analysisIndexKey].value === "teu_percentage") ? <span className="font-weight-bold">{"% share by" + this.state.search_type_options[this.state.analysisIndexKey].label.replace("% market share by", "")}</span> : <span>{"% share by" + this.state.search_type_options[this.state.analysisIndexKey].label.replace("% market share by", "")}</span>}</div>,
        key: "marketShare",
        sortable: false,
        grow: 1,
        selector: (row) => (
          <span>
            <strong> {!!row.marketShare && row.marketShare !== "" ? row.marketShare + "%" : "NA"}</strong>
          </span>
        ),
      },
    ];

    defaultViewAllColumnsClone = defaultViewAllColumnsClone.filter((item) => !item.omit);
    this.setState({
      defaultViewAllColumns: defaultViewAllColumnsClone,
    });
  }
  redirectingUser(data1, data2, data3, data4) {
    let tempObj = {
      analyticsViewAllKey: this.state.analyticsViewAllKey.value,
      filter_value1: "",
      filter_value2: !!data2 && data2 !== "" ? data2 : "",
      filter_value3: "",
      filter_value4: "",
      analysisOption: this.state.search_type_options[this.state.analysisIndexKey].value,
    };
    if (this.state.analyticsViewAllKey.value === "sections" || this.state.analyticsViewAllKey.value === "derived_hs_codes") {
      tempObj.filter_value1 = !!data1 && data1.length !== 0 ? data1 : [];
    } else {
      tempObj.filter_value1 = !!data1 && data1 !== "" ? data1 : "";
    }
    if (data3) tempObj.filter_value3 = data3;
    if (data4) tempObj.filter_value4 = data4;
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletViewAllApplyFilterButton, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    this.props.analyticsViewAllData(tempObj);
    this.props.hideViewAllModal(true);
  }
  detailModalClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.onCloseModal();
    this.setState({
      showViewAllModal: false,
      analyticsViewAll_mustnot_Data: [],
    });
    this.props.hideViewAllModal(true);
  };
  findAnalysisKeyInList(data) {
    if (!!data && data !== "") {
      let tempValue = "";
      for (let i = 0; i < this.state.search_type_options.length; i++) {
        if (data === this.state.search_type_options[i].value) {
          tempValue = this.state.search_type_options.indexOf(this.state.search_type_options[i]);
          break;
        }
      }
      this.setState({
        analysisIndexKey: tempValue,
      });
    }
  }
  mapHeadingInModal() {
    const data = this.props?.report?.primary_attribute_field ?? "";
    if (!!data && data !== "") {
      let tempValue = "";
      for (let i = 0; i < analyticsFieldKeys.length; i++) {
        if (data === analyticsFieldKeys[i].value) {
          tempValue = analyticsFieldKeys[i];
          break;
        }
      }
      this.setState({
        analyticsViewAllKey: tempValue,
      });
    }
  }
  mapCountryFrom(data) {
    if (data) {
      this.setState({
        fromCountry: data,
      });
    }
  }
  handlePerRowsChange(currentPage) {
    const requiredValue = currentPage * this.state.viewAllPerPage;
    if (!(!!this.state.defaultViewAllData[requiredValue + 1] && this.state.defaultViewAllData[requiredValue + 1] !== "") && this.state.totalViewAllData > this.state.defaultViewAllData.length) {
      this.bindGroupByResultValue(this.state.search_type_options[this.state.analysisIndexKey].value, "pagination_called");
    }
    this.setState({
      viewAllCurrentPage: currentPage,
      count: this.state.count + 1,
    });
  }
  handleSearchPerRowsChange(data) {
    this.setState({
      viewAllPerPage: data,
    });
  }

  selectTypeHandler(type) {
    this.setState({
      defaultTwoLevelColumn: type,
      valueChanged: this.props.currentKeyViewTrendItem.defaultKey === type ? false : true,
      defaultPage: 1,
      // isLoaderActive:true
    });
    setTimeout(() => {
      this.fetchAnalyticsViewAllData(this.props.viewAllFinalSearchReqObj);
    }, 200);
  }

  mapSelectedValue(data) {
    if (data) {
      setTimeout(() => {
        this.setState({
          selectedRows: [...data],
        });
      }, 100);
    }
  }
  callingDownloadAPI(data, isRangeViewAll) {
    const downloadPayload = {};
    if (!isRangeViewAll) {
      downloadPayload.data_download = [...data];
      downloadPayload._payload = this.state.existingReqObj;
      downloadPayload._payload.email = false;
    } else {
      downloadPayload._payload = this.state.existingReqObj;
      downloadPayload._payload.from = this.state.downloadFromValue - 1;
      downloadPayload._payload.size = Math.abs(this.state.downloadFromValue - this.state.downloadToValue) + 1;
      downloadPayload._payload.email = true;
      downloadPayload._payload.must_not = [];
    }
    if (this.state.showTwoLevel) {
      downloadPayload.subAnalyticsField = this.state.defaultTwoLevelColumn;
    }
    if (+this.state.downloadToValue < +this.state.downloadFromValue) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }
    downloadPayload.isSecondLevelAnalytics = this.state.showTwoLevel ? true : false;
    downloadPayload.isRangeViewAll = isRangeViewAll === true ? isRangeViewAll : false;
    downloadPayload.file_name = "Analytics_ViewAll_" + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    downloadPayload.analysis = !!this.props && !!this.props.report && this.props.report?.analysis_on;
    downloadPayload.tradeDirection = !!this.props && !!this.props.tradeDirection && this.props.tradeDirection !== "" ? this.props.tradeDirection : "";
    downloadPayload.country = !!this.props && !!this.props.country && this.props.country !== "" ? this.props.country : "";
    downloadPayload.analyticsField = !!this.props && !!this.props.report && this.props.report?.primary_attribute_field;
    if (isRangeViewAll) {
      axios.post(intelAPIEndpoints.downloadExcel, downloadPayload).then(
        (res) => {
          this.setState({
            isDownloadLoaderActive: false,
          });
          if (!!res && !!res.data && !!res.data.status && res.data.status === "success") {
            toast.success(res.data.message);
            this.setState({ showDownloadImpExpModal: false });
          } else {
            globalErrorHandling(res);
          }
        },
        () => {
          toast.error("Something went wrong. Please try again later !!!");
          this.setState({
            isDownloadLoaderActive: false,
          });
        }
      );
    } else {
      const request = new XMLHttpRequest();
      request.open("POST", intelAPIEndpoints.downloadExcel, true);
      request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      request.responseType = "blob";
      request.setRequestHeader("sessionId", localStorageService.getSessionID());
      request.setRequestHeader("ssoToken", localStorageService.getAccessToken());
      request.onload = function () {
        if (request.status === 200 && !isJsonResponse(request)) {
          const contentTypeHeader = request.getResponseHeader("Content-Type");
          const file = new Blob([this.response], { type: contentTypeHeader });
          const url = window.URL.createObjectURL(file);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = downloadPayload.file_name;
          a.click();
        } else {
          handleDownloadError(request);
        }
      };
      request.send(JSON.stringify(downloadPayload), this);
      this.setState({
        showDownloadImpExpModal: false,
      });
    }
  }

  downloadRangeFilter = () => {
    trademoTrackingEvents(this.getPendoKey(trackingEventDictionary.reportDownloadEmailConfirm), generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    this.callingDownloadAPI("", true);
  };

  levelTwoNextPageHandler = (paginationStr) => {
    let searchRequestObj = !!this && !!this.props && !!this.props.viewAllFinalSearchReqObj ? this.props.viewAllFinalSearchReqObj : {};
    if (!!paginationStr && paginationStr !== "") {
      searchRequestObj.must_not = this.state.analyticsViewAll_mustnot_Data;
    } else {
      this.setState({
        defaultViewAllData: [],
        analyticsViewAll_mustnot_Data: [],
        viewAllCurrentPage: 1,
        selectedRows: [],
      });
      searchRequestObj.must_not = [];
    }
    this.fetchAnalyticsViewAllData(searchRequestObj, paginationStr);
  };

  setDefaultPage = (page) => {
    this.setState({
      defaultPage: page,
    });
  };

  setMaxPaginate = (page) => {
    this.setState({
      maxPaginate: page,
    });
  };

  setViewAllPerPage = (page) => {
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletViewAll2ndLevelAnalyticsPaginationResultPerPage, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    this.setState({
      viewPerPage: page,
      defaultPage: 1,
    });
  };

  clearSelectedRows = () => {
    this.setState({
      selectedRows: [],
      clearButton: true,
    });
    setTimeout(() => {
      this.setState({
        clearButton: false,
      });
    }, 100);
  };

  updateviewAllTable = (data) => {
    this.setState({
      viewAllPerPage: data.perPage,
      viewAllCurrentPage: data.currentPage + 1,
    });
  };

  selectedRowCheck = (row) => {
    return this.state.selectedRows.includes(row) === true ? true : false;
  };

  goToNext = (e) => {
    e.preventDefault();
    // change 6 by reports length
    this.props.setCurrentViewedIndex((prevIndex) => (prevIndex !== null && prevIndex < this.props.reportsLength - 1 ? prevIndex + 1 : null));
    trademoTrackingEvents(trackingEventDictionary.reportPopupNext, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
  };
  goToPrevious = () => {
    this.props.setCurrentViewedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : null));
    trademoTrackingEvents(trackingEventDictionary.reportPopupPrevious, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
  };

  render() {
    return (
      <Modal
        onClick={() => {
          this.setState({ show: false });
          setTimeout(() => {
            this.openViewAllModal();
          }, 100);
        }}
        show={this.state.showViewAllModal}
        onHide={this.detailModalClose.bind(this)}
        size="xl"
        keyboard={false}
        centered
        className="trademo-modal trademo-trends-modal">
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between w-100 header">
            <div className="left">
              <h4>
                {this.props.index + 1} of {this.props.reportsLength} reports
              </h4>
              <div className="left-btns">
                <button className="prev-btn" onClick={this.goToPrevious} disabled={this.props.currentViewedIndex === 0}>
                  {" "}
                  <ChevronLeft size={20} /> <span>Previous Report</span>
                </button>
                <button className="next-btn" onClick={this.goToNext} disabled={this.props.currentViewedIndex === this.props.reportsLength - 1}>
                  <span>Next Report</span> <ChevronRight size={20} />
                </button>
              </div>
            </div>
            <div className="right">
              <button
                onClick={() => {
                  this.setState({
                    showDownloadImpExpModal: true,
                    downloadToValue: this.state.totalViewAllData < 100 ? this.state.totalViewAllData : 100,
                    downloadFromValue: 1,
                  });
                  trademoTrackingEvents(this.getPendoKey(trackingEventDictionary.reportDownloadEmail), generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
                }}
                className=" two_level_label donwload-btn-header">
                <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1707282581/intel/icons/agikmdw7iyfbtw3gbtv5.svg" alt="Email Icon" />
                Email Report
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-md-6 report-heading">
              <h4>{this.props.report?.report_name}</h4>
              {!!this.state.selectedRows && this.state.selectedRows !== "" && this.state.selectedRows.length > 0 ? (
                <div className="d-flex justify-content-between">
                  <div className={`selected-state-row d-flex align-items-center selected-top-box px-1 ${this.state.selectedRows.length > 0 ? null : "d-none"}`}>
                    <span className="mx-1">
                      {this.state.selectedRows.length > 0 ? (
                        <span className="selected-search-count d-flex align-items-center">
                          <span className={`row-select-count mr-1 ${this.state.selectedRows.length > 9 ? "padding" : "extra-padding"}`}>{this.state.selectedRows.length}</span>
                          <span>{this.state.selectedRows.length === 1 ? "row selected" : "rows selected"}</span>
                        </span>
                      ) : (
                        <></>
                      )}
                    </span>
                    <span className="vr mx-1"></span>
                    <span
                      className="mx-1 d-flex cursor-pointer align-items-center"
                      onClick={() => {
                        this.callingDownloadAPI(this.state.selectedRows);
                        trademoTrackingEvents(this.getPendoKey(trackingEventDictionary.reportDownloadConfirm), generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
                      }}>
                      <img className="pr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875670/intel/Importer-Exporter_Tab/leftbar_icon_download_fqdhxy.svg" alt="Download Icon" />
                      <span>Download</span>
                    </span>
                    <span className="vr mx-1"></span>
                    <span className="mx-1 d-flex cursor-pointer align-items-center" onClick={() => this.clearSelectedRows()}>
                      <img className="pr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875752/intel/Importer-Exporter_Tab/leftbar_icon_close_jl6z6l.svg" alt="Clear Icon" />
                      <span>Clear</span>
                    </span>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="row no-gutters">
            <div className="card w-100 trademo-datatable-card">
              {!!this && !!this.state && !!this.state.isLoaderActive && this.state.isLoaderActive === true ? (
                <>
                  <div className="container py-5 my-5 loading-container">
                    <div className="text-center pt-3">
                      <img src={LoaderImg} alt="description of gif" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {this.props.isViewAllGridNew && !this.state.showTwoLevel ? (
                    <ReactTableTrademo columns={this.state.defaultViewAllColumns} data={this.state.defaultViewAllData} paginationTotalRows={this.state.totalViewAllData} onSelectedRowsChange={(data) => this.mapSelectedValue(data)} paginationPerPage={this.state.viewAllPerPage} onChangeRowsPerPage={this.handleSearchPerRowsChange.bind(this)} onTableObjectChange={this.updateviewAllTable.bind(this)} onChangePage={this.handlePerRowsChange.bind(this)} paginationDefaultPage={this.state.viewAllCurrentPage} noDataComponent={this.state.isLoaderActive === true || this.state.isDownloadLoaderActive === true || this.state.isTrendsActive ? "" : "No Unique Importer Found"} clearSelectedRows={this.state.clearButton} selectedData={this.state.selectedRows} hideSorting={true} />
                  ) : !this.state.showTwoLevel ? (
                    <DataTable
                      className="trademo-datatable trademo-custom-table2"
                      // className='card w-100 trademo-modal-datatable'
                      title="Companies"
                      columns={this.state.defaultViewAllColumns}
                      data={!!this && !!this.state && !!this.state.defaultViewAllData && !!this.state.defaultViewAllData ? this.state.defaultViewAllData : []}
                      customStyles={customStyles}
                      pagination
                      persistTableHead
                      highlightOnHover
                      paginationIconFirstPage={<></>}
                      paginationIconLastPage={<></>}
                      noDataComponent={<NoSearchDataComponent content="No Shipments Found. Please try another search" />}
                      progressPending={!!this.state && this.state.loading}
                      selectableRows={!!this.props && !!this.props.country && this.props.country !== "" ? true : false}
                      selectableRowSelected={this.selectedRowCheck}
                      onSelectedRowsChange={({ selectedRows }) => this.mapSelectedValue(selectedRows)}
                      paginationComponentOptions={!!this.state && this.state.viewAllPaginationOptions}
                      paginationTotalRows={this.state.totalViewAllData}
                      paginationRowsPerPageOptions={[10, 20, 30]}
                      paginationPerPage={this.state.viewAllPerPage}
                      onChangePage={this.handlePerRowsChange.bind(this)}
                      onChangeRowsPerPage={this.handleSearchPerRowsChange.bind(this)}
                      paginationDefaultPage={this.state.viewAllCurrentPage}
                      clearSelectedRows={this.state.clearButton}
                    />
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
          {this.state.showTwoLevel && !this.state.isLoaderActive ? (
            <div>
              <ViewAllTwoLevelAnalytics columns={this.state.defaultViewAllColumns} twoLevelColumn={this.state.twoLevelColumn} customStyles={customStyles} twolevelData={this.state.twolevelData} analyticsType={this.props.analyticsType} count={this.state.totalViewAllData} defaultPage={this.state.defaultPage} setDefaultPage={this.setDefaultPage} setMaxPaginate={this.setMaxPaginate} maxPaginate={this.state.maxPaginate} levelTwoNextPageHandler={this.levelTwoNextPageHandler} setViewAllPerPage={this.setViewAllPerPage} viewAllPerPage={this.state.viewPerPage} currentKeyViewTrendItem={this.props.currentKeyViewTrendItem} pathname={this.props.pathname} analyticsCountryID={this.props.analyticsCountryID} currentUserPlan={this.props.currentUserPlan} />
            </div>
          ) : (
            ""
          )}
        </Modal.Body>

        <DownloadModal
          showModal={this.state.showDownloadImpExpModal}
          setShowModal={(val) =>
            this.setState({
              showDownloadImpExpModal: val,
            })
          }
          downloadFromValue={this.state.downloadFromValue}
          setDownloadFromValue={(val) => {
            this.setState({ downloadFromValue: val });
          }}
          downloadToValue={this.state.downloadToValue}
          setDownloadToValue={(val) => {
            this.setState({ downloadFromValue: val });
          }}
          dataCount={this.state.totalViewAllData}
          downloadRangeFilter={this.downloadRangeFilter}
        />
      </Modal>
    );
  }
}
